import { useQuery, useMutation } from "@tanstack/react-query";
import ApiClient from "../client";
import { ENDPOINTS } from "../endpoints";
import { queryKeys } from "../keys";

const client = new ApiClient(process.env.API_URL!, "app");
const clientShared = new ApiClient(process.env.API_URL!, "shared");

// Queries
export const useGetShareLinkData = (shareLinkId: string | null) =>
    useQuery({
        queryKey: queryKeys.sharedLink(shareLinkId),
        queryFn: () => {
            if (!shareLinkId) return null;
            return clientShared.get(ENDPOINTS.SHARE_LINK(shareLinkId));
        },
        enabled: !!shareLinkId,
    });

// Mutations
export const useCreateShareLink = () =>
    useMutation({
        mutationFn: (sharedData: any) =>
            client.post(ENDPOINTS.SHARE_LINKS, sharedData),
    });
